import apiCompetition from '@/api/competition-finances'

const state = {
  data: [],
  isLoading: false,
  error: null,
}

export const mutationTypes = {
  getCompetitionsStart: '[competition finance] Get competitions start',
  getCompetitionsSuccess: '[competition finance] Get competitions success',
  getCompetitionsFailure: '[competition finance] Get competitions failure',
}

export const actionTypes = {
  getCompetitions: '[competition finance] Get competition',
}

const mutations = {
  [mutationTypes.getCompetitionsStart](state) {
    state.isLoading = true
    state.error = null
    state.data = []
  },

  [mutationTypes.getCompetitionsSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getCompetitionsFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  },
}

const actions = {
  [actionTypes.getCompetitions](context, {id}) {
    context.commit(mutationTypes.getCompetitionsStart)
    return new Promise((resolve) => {
      apiCompetition
        .getCompetitionFinance(id)
        .then((response) => {
          context.commit(mutationTypes.getCompetitionsSuccess, response.data)
          resolve(response.data)
        })
        .catch((error) => {
          context.commit(mutationTypes.getCompetitionsFailure, error)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
